// extracted by mini-css-extract-plugin
export var text = "_n-0";